import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d306b86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "success" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Thank you for your submission!", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://www.linkedin.com/in/brenda-cayzac-138297103/" }, "LinkedIn", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://twitter.com/BrendaCayzac" }, "Twitter", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://www.behance.net/brendacayzeb7a?isa0=1" }, "Behance", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonButton = _resolveComponent("CommonButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", null, [
      _createTextVNode(_toDisplayString(_ctx.$t("You can always contact me via")) + " ", 1),
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createTextVNode(", " + _toDisplayString(_ctx.$t("or")) + " ", 1),
      _hoisted_6
    ]),
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => [
        _createVNode(_component_CommonButton, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("Home")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}